export const constitutionModalInitValue = {
  data: {
    date: '',
    comments: '',
    file: undefined,
    notaryName: '',
    notaryProtocol: '',
    notaryCity: '',
    scriptureView: true,
    lastOperationDate: '',
    totalSharesToAdd: 0,
    nominalValue: 0,
    selectedPartner: '',
    partnerOptions: [],
    sharesToAdd: 0,
    remainingShares: 0,
    hasPremium: false,
    premium: 0,
    selectedHoldingClass: '',
    defaultHoldingClassOption: null,
    holdingClassOptions: [],
    availableRange: { from: 0, to: 0 },
    historyMovements: [],
    isValidateRangeEnabled: false,
    isLoadingRange: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangeNotaryName(): void {},
    handleChangeNotaryProtocol(): void {},
    handleChangeNotaryCity(): void {},
    handleChangeTotalSharesToAdd(): void {},
    handleChangeNominalValue(): void {},
    handleChangePartner(): void {},
    handleSearchPartnerByTerm: async (): Promise<undefined> => undefined,
    handleChangeSharesToAdd(): void {},
    handleChangeHasPremium(): void {},
    handleChangePremium(): void {},
    handleChangeHoldingClass(): void {},
    handleValidateRange(): void {},
    handleSaveMovement(): void {},
    handleSaveConstitution(): void {},
  },
};
